// Rubber-Band Animation auf alle Ticket-Icons alle 15 Sekunden
// Läuft nur einmal pro Seite, egal wie viele Kuji-Produkte angezeigt werden
(function () {
  setInterval(() => {
    const icons = document.querySelectorAll('.ticket-icon');
    icons.forEach(icon => {
      icon.classList.add('rubber-band-trigger');
      setTimeout(() => {
        icon.classList.remove('rubber-band-trigger');
      }, 1200);
    });
  }, 15000);
})();
